import vars from './vars';

vars.$navBtn.on('click', (e) => {
	$(e.currentTarget).trigger('blur');

	vars.$nav.fadeToggle(100);
	vars.$html.toggleClass('is-nav-open');
});

vars.$navClose.on('click', (e) => {
	$(e.currentTarget).trigger('blur');

	vars.$nav.fadeOut(100);
	vars.$html.removeClass('is-nav-open');
	vars.$navList.scrollTop(0, 0);
});

vars.$navLink.on('click', (e) => {
	$(e.currentTarget).trigger('blur');

	vars.$nav.fadeOut(100);
	vars.$html.removeClass('is-nav-open');
	vars.$navList.scrollTop(0, 0);
});

vars.$navDown.on('click', (e) => {
	$(e.currentTarget).trigger('blur');

	vars.$navList.animate({
		scrollTop: vars.$navList.scrollTop() + $('.nav__list ul li:last-child').height(),
	}, 100);
});
